import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
// Local Deps
import './FilterGroup.scss';
import msgs from '../../config/messages';
import NFButton from '../primitives/NFButton';

// Initialize
const DEFAULT_FILTER_COUNT_LIMIT = 10;

export default class FilterGroup extends Component {
  static propTypes = {
    header: PropTypes.string.isRequired,
    groupKey: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        count: PropTypes.number,
      }),
    ).isRequired,
    onFilterClick: PropTypes.func.isRequired,
    selectedFilter: PropTypes.array,
    targetedProperty: PropTypes.string,
  };

  static defaultProps = {
    selectedFilter: [],
    targetedProperty: 'value',
  };

  static initialState = {
    filterCountLimit: DEFAULT_FILTER_COUNT_LIMIT,
  };

  static _generateFilters({
    filters,
    filterCountLimit,
    onFilterClick,
    groupKey,
    selectedFilter,
    targetedProperty,
  }) {
    const visibleFilters = filters
      .sort((a, b) => a < b)
      .slice(0, filterCountLimit);

    return visibleFilters.map(filter => {
      const isSelected = selectedFilter.includes(filter[targetedProperty]);
      return (
        <NFButton
          className={`nf-filter-group__button nf-button--transparent ${isSelected &&
            'nf-button--selected'}`}
          onClick={() => {
            onFilterClick(filter, groupKey);
          }}
          key={filter.value}
        >
          <span className="nf-filter_group__filter-text">{filter.text}</span>
          {filter.count && (
            <span className="nf-filter-group__filter-count">
              ({filter.count})
            </span>
          )}
        </NFButton>
      );
    });
  }
  state = FilterGroup.initialState;

  _onViewAllClick(filters) {
    this.setState({
      filterCountLimit: filters.length,
    });
  }

  _onViewLessClick = () => {
    this.setState({
      filterCountLimit: DEFAULT_FILTER_COUNT_LIMIT,
    });
  };

  render() {
    const { _generateFilters } = FilterGroup;

    const { filterCountLimit } = this.state;

    const {
      filters,
      header,
      onFilterClick,
      groupKey,
      selectedFilter,
      targetedProperty,
    } = this.props;

    const shouldShowViewOptons = DEFAULT_FILTER_COUNT_LIMIT < filters.length;
    const showViewAllButton =
      shouldShowViewOptons && filterCountLimit === DEFAULT_FILTER_COUNT_LIMIT;
    const showViewLessButton =
      shouldShowViewOptons && filterCountLimit > DEFAULT_FILTER_COUNT_LIMIT;

    return (
      <div className="nf-filter-group">
        {/* <!-- HEADER --> */}
        <h4 className="nf-filter-group__header">{header}</h4>
        {/* <!-- FILTERS --> */}
        <div className="nf-filter-group__divider" />
        {!isEmpty(filters) &&
          _generateFilters({
            filters,
            filterCountLimit,
            onFilterClick,
            groupKey,
            selectedFilter,
            targetedProperty,
          })}
        {/* <!-- VIEW ALL --> */}
        {showViewAllButton && (
          <NFButton
            className="nf-filter-group__button nf-filter-group__button--caps nf-button--transparent"
            onClick={() => this._onViewAllClick(filters)}
          >
            <span>{msgs.FilterGroup.viewAll}</span>
          </NFButton>
        )}
        {/* <!-- VIEW ALL --> */}
        {showViewLessButton && (
          <NFButton
            className="nf-filter-group__button nf-filter-group__button--caps nf-button--transparent"
            onClick={this._onViewLessClick}
          >
            <span>{msgs.FilterGroup.viewLess}</span>
          </NFButton>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterGroup/FilterGroup.jsx